export default __webpack_public_path__ + "static/media/pantry1-afterD-1024w.68d849f2.png";